var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNounElectrical2958711(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.782,
    height: 35.123,
    viewBox: "0 0 48.782 35.123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-electrical-2958711",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M105.061,92.387a17.19,17.19,0,0,0-9.35,9.35,17.978,17.978,0,0,0-1.382,6.829,17.065,17.065,0,0,0,1.057,6.016L87.5,119.136H97.907a16.958,16.958,0,0,0,5.935,5.041,17.631,17.631,0,0,0,8.13,1.951,17.978,17.978,0,0,0,6.829-1.382,17.189,17.189,0,0,0,9.35-9.35,17.978,17.978,0,0,0,1.382-6.829,17.065,17.065,0,0,0-1.057-6.016c3.171-1.789,5.691-3.252,5.691-3.252l2.114-1.3H125.875a16.958,16.958,0,0,0-5.935-5.041A17.631,17.631,0,0,0,111.81,91,17.887,17.887,0,0,0,105.061,92.387Zm25.854,7.073-16.261,9.349-1.545-2.683,6.423-3.74H110.1l8.781,15.285H92.866l16.261-9.349,1.545,2.683-6.423,3.74h9.431L104.9,99.461Z",
    transform: "translate(-87.5 -91.005)",
    fill: "#0f8a45"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounElectrical2958711);
export default __webpack_public_path__ + "static/media/noun-electrical-2958711.6e196a379ef862f90242c71b0a3be894.svg";
export { ForwardRef as ReactComponent };